import React from 'react';
import { Box, Typography } from '@mui/material';

const Error: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        minHeight: '100dvh',
      }}
    >
      <Typography variant="h1">404 Not Found</Typography>
      <Typography variant="h6">お探しのページは存在しません。</Typography>
    </Box>
  );
};

export default Error;
